export const surveyParticipationFetchSurveyStart = (state, payload) => {
  return {
    ...state,
    participationSurveyDetailsApi: {
      isProcessing: true,
      error: false,
      reason: '',
      surveyDetails: [],
      isDataFetched:false
    },
  };
};
export const surveyParticipationFetchSurveySuccess = (state, payload) => {
  let data =
    (payload.data &&
      payload.data.hits &&
      payload.data.hits.length &&
      payload.data.hits[0]) ||
    [];
  return {
    ...state,
    participationSurveyDetailsApi: {
      isProcessing: false,
      error: false,
      reason: '',
      surveyDetails: data,
      isDataFetched:true
    },
  };
};

export const surveyParticipationFetchSurveyFailed = (state, payload) => {
  return {
    ...state,
    participationSurveyDetailsApi: {
      isProcessing: false,
      error: true,
      reason: payload.error,
      surveyDetails: [],
      isDataFetched:false
    },
  };
};
